export const handleCardIcon = (kind) => {
  if (kind === 'VISA') return 'cards-visuals-visa';
  else if (kind === 'MASTERCARD' || kind === 'MC') return 'cards-visuals-mastercard';
  else if (kind === 'DISCOVER') return 'cards-visuals-discover';
  else if (kind === 'AMEX') return 'cards-visuals-amex';
  else if (kind === 'Debit MasterCard') return 'cards-visuals-mastercard';
  else if (kind === 'Diners') return 'cards-visuals-diners';
  else if (kind === 'Discover') return 'cards-visuals-discover';
  else if (kind === 'JCB') return 'cards-visuals-jcb';
  else if (kind === 'Maestro') return 'cards-visuals-maestro';
  else if (kind === 'MasterCard') return 'cards-visuals-mastercard';
  else if (kind === 'Visa Credit') return 'cards-visuals-visa';
  else if (kind === 'Visa Debit') return 'cards-visuals-visa';
  else if (kind === 'Visa Electron') return 'cards-visuals-visa';
  else return 'credit-card-mono';
};
